// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uDd1","rootMobile":"styles_rootMobile__3QGNW"};